import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.map";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import { Kind, valueFromASTUntyped, buildClientSchema, isNullableType, isNonNullType, isListType, GraphQLObjectType, GraphQLInterfaceType, GraphQLUnionType } from "graphql";
import { stringifyVariables, createRequest, formatDocument } from "urql";
import { asMutable, make, clearOptimistic, get, setOptimistic, remove } from "pessimism";
import { share, tap, map, filter, merge } from "wonka";

function _extends() {
  return (_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }).apply(this, arguments);
}

var getName = function getName(node) {
  return node.name.value;
};

var getFragmentTypeName = function getFragmentTypeName(node) {
  return node.typeCondition.name.value;
};

var getFieldAlias = function getFieldAlias(node) {
  return void 0 !== node.alias ? node.alias.value : getName(node);
};

var getSelectionSet = function getSelectionSet(node) {
  return void 0 !== node.selectionSet ? node.selectionSet.selections : [];
};

var getTypeCondition = function getTypeCondition(ref) {
  var typeCondition = ref.typeCondition;
  return void 0 !== typeCondition ? getName(typeCondition) : null;
};

var isFieldNode = function isFieldNode(node) {
  return node.kind === Kind.FIELD;
};

var isInlineFragment = function isInlineFragment(node) {
  return node.kind === Kind.INLINE_FRAGMENT;
};

var getFieldArguments = function getFieldArguments(node, vars) {
  if (void 0 === node.arguments || 0 === node.arguments.length) {
    return null;
  }

  var args = Object.create(null);
  var argsSize = 0;

  for (var i = 0, l = node.arguments.length; i < l; i++) {
    var arg = node.arguments[i];
    var value = valueFromASTUntyped(arg.value, vars);

    if (null != value) {
      args[getName(arg)] = value;
      argsSize++;
    }
  }

  return argsSize > 0 ? args : null;
};

var normalizeVariables = function normalizeVariables(node, input) {
  if (void 0 === node.variableDefinitions) {
    return {};
  }

  var args = input || {};
  return node.variableDefinitions.reduce(function (vars, def) {
    var name = getName(def.variable);
    var value = args[name];

    if (void 0 === value) {
      if (void 0 !== def.defaultValue) {
        value = valueFromASTUntyped(def.defaultValue, args);
      } else {
        return vars;
      }
    }

    vars[name] = value;
    return vars;
  }, Object.create(null));
};

var helpUrl = "\nhttps://github.com/FormidableLabs/urql-exchange-graphcache/blob/master/docs/help.md#";
var cache = new Set();

var invariant = function invariant(clause, message, code) {
  if (!clause) {
    var error = new Error((message || "Minfied Error #" + code + "\n") + helpUrl + code);
    error.name = "Graphcache Error";
    throw error;
  }
};

var warning = function warning(clause, message, code) {
  if (!clause && !cache.has(message)) {
    console.warn(message + helpUrl + code);
    cache.add(message);
  }
};

var isFragmentNode = function isFragmentNode(node) {
  return node.kind === Kind.FRAGMENT_DEFINITION;
};

function _ref(node) {
  return node.kind === Kind.OPERATION_DEFINITION;
}

var getMainOperation = function getMainOperation(doc) {
  var operation = doc.definitions.find(_ref);
  invariant(!!operation, "production" !== process.env.NODE_ENV ? "Invalid GraphQL document: All GraphQL documents must contain an OperationDefinitionnode for a query, subscription, or mutation." : "", 1);
  return operation;
};

function _ref2(map, node) {
  map[getName(node)] = node;
  return map;
}

var getFragments = function getFragments(doc) {
  return doc.definitions.filter(isFragmentNode).reduce(_ref2, {});
};

var shouldInclude = function shouldInclude(node, vars) {
  var directives = node.directives;

  if (void 0 === directives) {
    return !0;
  }

  for (var i = 0, l = directives.length; i < l; i++) {
    var directive = directives[i];
    var name = getName(directive);
    var isInclude = "include" === name;

    if (!isInclude && "skip" !== name) {
      continue;
    }

    var arg = directive.arguments ? directive.arguments[0] : null;

    if (!arg || "if" !== getName(arg)) {
      continue;
    }

    var value = valueFromASTUntyped(arg.value, vars);

    if ("boolean" != typeof value && null !== value) {
      continue;
    }

    return isInclude ? !!value : !value;
  }

  return !0;
};

var keyOfField = function keyOfField(fieldName, args) {
  return args ? fieldName + "(" + stringifyVariables(args) + ")" : fieldName;
};

var joinKeys = function joinKeys(parentKey, key) {
  return parentKey + "." + key;
};

var isFragmentHeuristicallyMatching = function isFragmentHeuristicallyMatching(node, typename, entityKey, ctx) {
  if (!typename) {
    return !1;
  }

  var typeCondition = getTypeCondition(node);

  if (typename === typeCondition) {
    return !0;
  }

  "production" !== process.env.NODE_ENV && warning(!1, "Heuristic Fragment Matching: A fragment is trying to match against the `" + typename + "` type, but the type condition is `" + typeCondition + "`. Since GraphQL allows for interfaces `" + typeCondition + "` may be aninterface.\nA schema needs to be defined for this match to be deterministic, otherwise the fragment will be matched heuristically!", 16);
  return !getSelectionSet(node).some(function (node) {
    if (!isFieldNode(node)) {
      return !1;
    }

    var fieldKey = keyOfField(getName(node), getFieldArguments(node, ctx.variables));
    return !ctx.store.hasField(joinKeys(entityKey, fieldKey));
  });
};

var SelectionIterator = function SelectionIterator(typename, entityKey, select, ctx) {
  this.typename = typename;
  this.entityKey = entityKey;
  this.context = ctx;
  this.indexStack = [0];
  this.selectionStack = [select];
};

SelectionIterator.prototype.next = function next() {
  while (0 !== this.indexStack.length) {
    var index = this.indexStack[this.indexStack.length - 1]++;
    var select = this.selectionStack[this.selectionStack.length - 1];

    if (index >= select.length) {
      this.indexStack.pop();
      this.selectionStack.pop();
      continue;
    } else {
      var node = select[index];

      if (!shouldInclude(node, this.context.variables)) {
        continue;
      } else if (!isFieldNode(node)) {
        var fragmentNode = !isInlineFragment(node) ? this.context.fragments[getName(node)] : node;

        if (void 0 !== fragmentNode) {
          if (void 0 !== this.context.schemaPredicates ? this.context.schemaPredicates.isInterfaceOfType(getTypeCondition(fragmentNode), this.typename) : isFragmentHeuristicallyMatching(fragmentNode, this.typename, this.entityKey, this.context)) {
            this.indexStack.push(0);
            this.selectionStack.push(getSelectionSet(fragmentNode));
          }
        }

        continue;
      } else if ("__typename" === getName(node)) {
        continue;
      } else {
        return node;
      }
    }
  }

  return;
};

var isScalar = function isScalar(x) {
  if (Array.isArray(x)) {
    return x.some(isScalar);
  }

  return "object" != typeof x || null !== x && "string" != typeof x.__typename;
};

var write = function write(store, request, data) {
  initStoreState(0);
  var result = startWrite(store, request, data);
  clearStoreState();
  return result;
};

var startWrite = function startWrite(store, request, data) {
  var operation = getMainOperation(request.query);
  var result = {
    dependencies: getCurrentDependencies()
  };
  var select = getSelectionSet(operation);
  var operationName = store.getRootKey(operation.operation);
  var ctx = {
    parentTypeName: operationName,
    parentKey: operationName,
    parentFieldKey: "",
    fieldName: "",
    variables: normalizeVariables(operation, request.variables),
    fragments: getFragments(request.query),
    result: result,
    store: store,
    schemaPredicates: store.schemaPredicates
  };

  if (operationName === ctx.store.getRootKey("query")) {
    writeSelection(ctx, operationName, select, data);
  } else {
    writeRoot(ctx, operationName, select, data);
  }

  return result;
};

var writeOptimistic = function writeOptimistic(store, request, optimisticKey) {
  initStoreState(optimisticKey);
  var operation = getMainOperation(request.query);
  var result = {
    dependencies: getCurrentDependencies()
  };
  var mutationRootKey = store.getRootKey("mutation");
  var operationName = store.getRootKey(operation.operation);
  invariant(operationName === mutationRootKey, "production" !== process.env.NODE_ENV ? "writeOptimistic(...) was called with an operation that is not a mutation.\nThis case is unsupported and should never occur." : "", 10);
  var ctx = {
    parentTypeName: mutationRootKey,
    parentKey: mutationRootKey,
    parentFieldKey: "",
    fieldName: "",
    variables: normalizeVariables(operation, request.variables),
    fragments: getFragments(request.query),
    result: result,
    store: store,
    schemaPredicates: store.schemaPredicates,
    optimistic: !0
  };
  var data = Object.create(null);
  var iter = new SelectionIterator(operationName, operationName, getSelectionSet(operation), ctx);
  var node;

  while (void 0 !== (node = iter.next())) {
    if (void 0 !== node.selectionSet) {
      var fieldName = getName(node);
      var resolver = ctx.store.optimisticMutations[fieldName];

      if (void 0 !== resolver) {
        ctx.fieldName = fieldName;
        var fieldArgs = getFieldArguments(node, ctx.variables);
        var resolverValue = resolver(fieldArgs || Object.create(null), ctx.store, ctx);

        if (!isScalar(resolverValue)) {
          writeRootField(ctx, resolverValue, getSelectionSet(node));
        }

        data[fieldName] = resolverValue;
        var updater = ctx.store.updates[mutationRootKey][fieldName];

        if (void 0 !== updater) {
          updater(data, fieldArgs || Object.create(null), ctx.store, ctx);
        }
      }
    }
  }

  clearStoreState();
  return result;
};

var writeFragment = function writeFragment(store, query, data, variables) {
  var fragments = getFragments(query);
  var fragment = fragments[Object.keys(fragments)[0]];

  if (void 0 === fragment) {
    return "production" !== process.env.NODE_ENV ? warning(!1, "writeFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 11) : void 0;
  }

  var typename = getFragmentTypeName(fragment);

  var writeData = _extends({
    __typename: typename
  }, data);

  var entityKey = store.keyOfEntity(writeData);

  if (!entityKey) {
    return "production" !== process.env.NODE_ENV ? warning(!1, "Can't generate a key for writeFragment(...) data.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + typename + "`.", 12) : void 0;
  }

  var ctx = {
    parentTypeName: typename,
    parentKey: entityKey,
    parentFieldKey: "",
    fieldName: "",
    variables: variables || {},
    fragments: fragments,
    result: {
      dependencies: getCurrentDependencies()
    },
    store: store,
    schemaPredicates: store.schemaPredicates
  };
  writeSelection(ctx, entityKey, getSelectionSet(fragment), writeData);
};

var writeSelection = function writeSelection(ctx, entityKey, select, data) {
  var store = ctx.store;
  var isQuery = entityKey === ctx.store.getRootKey("query");
  var typename = data.__typename;

  if (!isQuery) {
    addDependency(entityKey);
  }

  store.writeField(isQuery ? entityKey : typename, entityKey, "__typename");
  var iter = new SelectionIterator(typename, entityKey, select, ctx);
  var node;

  while (void 0 !== (node = iter.next())) {
    var fieldName = getName(node);
    var fieldArgs = getFieldArguments(node, ctx.variables);
    var fieldKey = joinKeys(entityKey, keyOfField(fieldName, fieldArgs));
    var fieldValue = data[getFieldAlias(node)];

    if (isQuery) {
      addDependency(fieldKey);
    }

    if ("production" !== process.env.NODE_ENV) {
      if (void 0 === fieldValue) {
        "production" !== process.env.NODE_ENV && warning(!1, "Invalid undefined: The field at `" + fieldKey + "` is `undefined`, but the GraphQL query expects a " + (void 0 === node.selectionSet ? "scalar (number, boolean, etc)" : "selection set") + " for this field." + (ctx.optimistic ? "\nYour optimistic result may be missing a field!" : ""), 13);
        continue;
      } else if (ctx.schemaPredicates && typename) {
        ctx.schemaPredicates.isFieldAvailableOnType(typename, fieldName);
      }
    }

    if (void 0 === node.selectionSet) {
      store.writeRecord(fieldValue, fieldKey);
    } else if (!isScalar(fieldValue)) {
      var link = writeField(ctx, fieldKey, getSelectionSet(node), fieldValue);
      store.writeConnection(joinKeys(entityKey, fieldName), fieldKey, fieldArgs);
      store.writeLink(link, fieldKey);
      store.removeRecord(fieldKey);
    } else {
      "production" !== process.env.NODE_ENV && warning(!1, "Invalid value: The field at `" + fieldKey + "` is a scalar (number, boolean, etc), but the GraphQL query expects a selection set for this field.\nThe value will still be cached, however this may lead to undefined behavior!", 14);
      store.writeRecord(fieldValue, fieldKey);
    }
  }
};

var writeField = function writeField(ctx, parentFieldKey, select, data) {
  if (Array.isArray(data)) {
    var newData = new Array(data.length);

    for (var i = 0, l = data.length; i < l; i++) {
      var item = data[i];
      var indexKey = joinKeys(parentFieldKey, "" + i);
      var links = writeField(ctx, indexKey, select, item);
      newData[i] = links;
    }

    return newData;
  } else if (null === data) {
    return null;
  }

  var entityKey = ctx.store.keyOfEntity(data);
  var key = null !== entityKey ? entityKey : parentFieldKey;

  if ("string" != typeof data.__typename || void 0 === ctx.store.keys[data.__typename] && null === entityKey) {
    var typename = data.__typename;
    "production" !== process.env.NODE_ENV && warning(typename.endsWith("Connection") || typename.endsWith("Edge") || "PageInfo" === typename, "Invalid key: The GraphQL query at the field at `" + parentFieldKey + "` has a selection set, but no key could be generated for the data at this field.\nYou have to request `id` or `_id` fields for all selection sets or create a custom `keys` config for `" + typename + "`.\nEntities without keys will be embedded directly on the parent entity. If this is intentional, create a `keys` config for `" + typename + "` that always returns null.", 15);
  }

  writeSelection(ctx, key, select, data);
  return key;
};

var writeRoot = function writeRoot(ctx, typename, select, data) {
  var isRootField = typename === ctx.store.getRootKey("mutation") || typename === ctx.store.getRootKey("subscription");
  var iter = new SelectionIterator(typename, typename, select, ctx);
  var node;

  while (void 0 !== (node = iter.next())) {
    var fieldName = getName(node);
    var fieldArgs = getFieldArguments(node, ctx.variables);
    var fieldValue = data[getFieldAlias(node)];

    if (void 0 !== node.selectionSet && null !== fieldValue && !isScalar(fieldValue)) {
      writeRootField(ctx, fieldValue, getSelectionSet(node));
    }

    if (isRootField) {
      ctx.parentTypeName = typename;
      ctx.parentKey = typename;
      ctx.parentFieldKey = joinKeys(typename, keyOfField(fieldName, fieldArgs));
      ctx.fieldName = fieldName;
      var updater = ctx.store.updates[typename][fieldName];

      if (void 0 !== updater) {
        updater(data, fieldArgs || Object.create(null), ctx.store, ctx);
      }
    }
  }
};

var writeRootField = function writeRootField(ctx, data, select) {
  if (Array.isArray(data)) {
    var newData = new Array(data.length);

    for (var i = 0, l = data.length; i < l; i++) {
      newData[i] = writeRootField(ctx, data[i], select);
    }

    return newData;
  } else if (null === data) {
    return;
  }

  var entityKey = ctx.store.keyOfEntity(data);

  if (null !== entityKey) {
    writeSelection(ctx, entityKey, select, data);
  } else {
    writeRoot(ctx, data.__typename, select, data);
  }
};

var invalidateSelection = function invalidateSelection(ctx, entityKey, select) {
  var store = ctx.store;
  var isQuery = "Query" === entityKey;
  var typename;

  if (!isQuery) {
    addDependency(entityKey);

    if ("string" != typeof (typename = store.getField(entityKey, "__typename"))) {
      return;
    } else {
      store.removeRecord(joinKeys(entityKey, keyOfField("__typename")));
    }
  } else {
    typename = entityKey;
  }

  var iter = new SelectionIterator(typename, entityKey, select, ctx);
  var node;

  while (void 0 !== (node = iter.next())) {
    var fieldName = getName(node);
    var fieldKey = joinKeys(entityKey, keyOfField(fieldName, getFieldArguments(node, ctx.variables)));

    if ("production" !== process.env.NODE_ENV && ctx.schemaPredicates && typename) {
      ctx.schemaPredicates.isFieldAvailableOnType(typename, fieldName);
    }

    if (isQuery) {
      addDependency(fieldKey);
    }

    if (void 0 === node.selectionSet) {
      store.removeRecord(fieldKey);
    } else {
      var fieldSelect = getSelectionSet(node);
      var link = store.getLink(fieldKey);
      store.removeLink(fieldKey);

      if (void 0 === link) {
        if (void 0 !== store.getRecord(fieldKey)) {
          store.removeRecord(fieldKey);
        }
      } else if (Array.isArray(link)) {
        for (var i = 0, l = link.length; i < l; i++) {
          var childLink = link[i];

          if (null !== childLink) {
            invalidateSelection(ctx, childLink, fieldSelect);
          }
        }
      } else if (null !== link) {
        invalidateSelection(ctx, link, fieldSelect);
      }
    }
  }
};

var currentDependencies = {
  current: null
};
var currentOptimisticKey = {
  current: null
};

var initStoreState = function initStoreState(optimisticKey) {
  currentDependencies.current = new Set();
  currentOptimisticKey.current = optimisticKey;
};

var clearStoreState = function clearStoreState() {
  currentDependencies.current = null;
  currentOptimisticKey.current = null;
};

var getCurrentDependencies = function getCurrentDependencies() {
  return function (ref) {
    invariant(null !== ref.current, "production" !== process.env.NODE_ENV ? "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs." : "", 2);
    return ref.current;
  }(currentDependencies);
};

var addDependency = function addDependency(dependency) {
  currentDependencies.current.add(dependency);
};

var mapSet = function mapSet(map, key, value) {
  return setOptimistic(map, key, value, currentOptimisticKey.current || 0);
};

var mapRemove = function mapRemove(map, key) {
  var optimisticKey = currentOptimisticKey.current || 0;
  return optimisticKey ? setOptimistic(map, key, void 0, optimisticKey) : remove(map, key);
};

var Store = function Store(schemaPredicates, resolvers, updates, optimisticMutations, keys) {
  var obj;
  this.records = asMutable(make());
  this.connections = asMutable(make());
  this.links = asMutable(make());
  this.resolvers = resolvers || {};
  this.optimisticMutations = optimisticMutations || {};
  this.keys = keys || {};
  this.schemaPredicates = schemaPredicates;
  this.updates = {
    Mutation: updates && updates.Mutation || {},
    Subscription: updates && updates.Subscription || {}
  };

  if (schemaPredicates) {
    var schema = schemaPredicates.schema;
    var queryType = schema.getQueryType();
    var mutationType = schema.getMutationType();
    var subscriptionType = schema.getSubscriptionType();
    var queryName = queryType ? queryType.name : "Query";
    var mutationName = mutationType ? mutationType.name : "Mutation";
    var subscriptionName = subscriptionType ? subscriptionType.name : "Subscription";
    this.rootFields = {
      query: queryName,
      mutation: mutationName,
      subscription: subscriptionName
    };
    this.rootNames = ((obj = {})[queryName] = "query", obj[mutationName] = "mutation", obj[subscriptionName] = "subscription", obj);
  } else {
    this.rootFields = {
      query: "Query",
      mutation: "Mutation",
      subscription: "Subscription"
    };
    this.rootNames = {
      Query: "query",
      Mutation: "mutation",
      Subscription: "subscription"
    };
  }
};

Store.prototype.getRootKey = function getRootKey(name) {
  return this.rootFields[name];
};

Store.prototype.keyOfEntity = function keyOfEntity(data) {
  var typename = data.__typename;
  var id = data.id;
  var _id = data._id;

  if (!typename) {
    return null;
  } else if (this.rootNames[typename]) {
    return this.rootNames[typename];
  }

  var key;

  if (this.keys[typename]) {
    key = this.keys[typename](data);
  } else if (null != id) {
    key = "" + id;
  } else if (null != _id) {
    key = "" + _id;
  }

  return key ? typename + ":" + key : null;
};

Store.prototype.clearOptimistic = function clearOptimistic$1(optimisticKey) {
  this.records = clearOptimistic(this.records, optimisticKey);
  this.connections = clearOptimistic(this.connections, optimisticKey);
  this.links = clearOptimistic(this.links, optimisticKey);
};

Store.prototype.getRecord = function getRecord(fieldKey) {
  return get(this.records, fieldKey);
};

Store.prototype.removeRecord = function removeRecord(fieldKey) {
  return this.records = mapRemove(this.records, fieldKey);
};

Store.prototype.writeRecord = function writeRecord(field, fieldKey) {
  return this.records = mapSet(this.records, fieldKey, field);
};

Store.prototype.getField = function getField(entityKey, fieldName, args) {
  return this.getRecord(joinKeys(entityKey, keyOfField(fieldName, args)));
};

Store.prototype.writeField = function writeField(field, entityKey, fieldName, args) {
  return this.records = mapSet(this.records, joinKeys(entityKey, keyOfField(fieldName, args)), field);
};

Store.prototype.getLink = function getLink(key) {
  return get(this.links, key);
};

Store.prototype.removeLink = function removeLink(key) {
  return this.links = mapRemove(this.links, key);
};

Store.prototype.writeLink = function writeLink(link, key) {
  return this.links = mapSet(this.links, key, link);
};

Store.prototype.writeConnection = function writeConnection(key, linkKey, args) {
  if (void 0 !== this.getLink(linkKey) || null === args) {
    return this.connections;
  }

  var connections = get(this.connections, key);
  var connection = [args, linkKey];

  if (void 0 === connections) {
    connections = [connection];
  } else {
    for (var i = 0, l = connections.length; i < l; i++) {
      if (connections[i][1] === linkKey) {
        return this.connections;
      }
    }

    (connections = connections.slice()).push(connection);
  }

  return this.connections = mapSet(this.connections, key, connections);
};

Store.prototype.resolveValueOrLink = function resolveValueOrLink(fieldKey) {
  var fieldValue = this.getRecord(fieldKey);

  if (void 0 !== fieldValue) {
    return fieldValue;
  }

  var link = this.getLink(fieldKey);
  return link ? link : null;
};

Store.prototype.resolve = function resolve(entity, field, args) {
  if (null === entity) {
    return null;
  } else if ("string" == typeof entity) {
    addDependency(entity);
    return this.resolveValueOrLink(joinKeys(entity, keyOfField(field, args)));
  } else {
    var entityKey = this.keyOfEntity(entity);

    if (null === entityKey) {
      return null;
    }

    addDependency(entityKey);
    return this.resolveValueOrLink(joinKeys(entityKey, keyOfField(field, args)));
  }
};

Store.prototype.resolveConnections = function resolveConnections(entity, field) {
  var connections;

  if ("string" == typeof entity) {
    connections = get(this.connections, joinKeys(entity, field));
  } else if (null !== entity) {
    var entityKey = this.keyOfEntity(entity);

    if (null !== entityKey) {
      addDependency(entityKey);
      connections = get(this.connections, joinKeys(entityKey, field));
    }
  }

  return void 0 !== connections ? connections : [];
};

Store.prototype.invalidateQuery = function invalidateQuery(query, variables) {
  !function (store, request) {
    initStoreState(0);
    var operation = getMainOperation(request.query);
    var ctx = {
      variables: normalizeVariables(operation, request.variables),
      fragments: getFragments(request.query),
      store: store,
      schemaPredicates: store.schemaPredicates
    };
    invalidateSelection(ctx, ctx.store.getRootKey("query"), getSelectionSet(operation));
    clearStoreState();
  }(this, createRequest(query, variables));
};

Store.prototype.hasField = function hasField(key) {
  return void 0 !== this.getRecord(key) || void 0 !== this.getLink(key);
};

Store.prototype.updateQuery = function updateQuery(input, updater) {
  var request = createRequest(input.query, input.variables);
  var output = updater(this.readQuery(request));

  if (null !== output) {
    startWrite(this, request, output);
  }
};

Store.prototype.readQuery = function readQuery(input) {
  return read(this, createRequest(input.query, input.variables)).data;
};

Store.prototype.readFragment = function readFragment$1(dataFragment, entity, variables) {
  return readFragment(this, dataFragment, entity, variables);
};

Store.prototype.writeFragment = function writeFragment$1(dataFragment, data, variables) {
  writeFragment(this, dataFragment, data, variables);
};

var query = function query(store, request, data) {
  initStoreState(0);
  var result = read(store, request, data);
  clearStoreState();
  return result;
};

var read = function read(store, request, input) {
  var operation = getMainOperation(request.query);
  var rootKey = store.getRootKey(operation.operation);
  var rootSelect = getSelectionSet(operation);
  var ctx = {
    parentTypeName: rootKey,
    parentKey: rootKey,
    parentFieldKey: "",
    fieldName: "",
    variables: normalizeVariables(operation, request.variables),
    fragments: getFragments(request.query),
    partial: !1,
    store: store,
    schemaPredicates: store.schemaPredicates
  };
  var data = input || Object.create(null);
  data = rootKey !== ctx.store.getRootKey("query") ? readRoot(ctx, rootKey, rootSelect, data) : readSelection(ctx, rootKey, rootSelect, data);
  return {
    dependencies: getCurrentDependencies(),
    partial: void 0 === data ? !1 : ctx.partial,
    data: void 0 === data ? null : data
  };
};

var readRoot = function readRoot(ctx, entityKey, select, originalData) {
  if ("string" != typeof originalData.__typename) {
    return originalData;
  }

  var data = Object.create(null);
  data.__typename = originalData.__typename;
  var iter = new SelectionIterator(entityKey, entityKey, select, ctx);
  var node;

  while (void 0 !== (node = iter.next())) {
    var fieldAlias = getFieldAlias(node);
    var fieldValue = originalData[fieldAlias];

    if (void 0 !== node.selectionSet && null !== fieldValue && !isScalar(fieldValue)) {
      data[fieldAlias] = readRootField(ctx, getSelectionSet(node), fieldValue);
    } else {
      data[fieldAlias] = fieldValue;
    }
  }

  return data;
};

var readRootField = function readRootField(ctx, select, originalData) {
  if (Array.isArray(originalData)) {
    var newData = new Array(originalData.length);

    for (var i = 0, l = originalData.length; i < l; i++) {
      newData[i] = readRootField(ctx, select, originalData[i]);
    }

    return newData;
  } else if (null === originalData) {
    return null;
  }

  var entityKey = ctx.store.keyOfEntity(originalData);

  if (null !== entityKey) {
    var fieldValue = readSelection(ctx, entityKey, select, Object.create(null));
    return void 0 === fieldValue ? null : fieldValue;
  } else {
    return readRoot(ctx, originalData.__typename, select, originalData);
  }
};

var readFragment = function readFragment(store, query, entity, variables) {
  var fragments = getFragments(query);
  var fragment = fragments[Object.keys(fragments)[0]];

  if (void 0 === fragment) {
    "production" !== process.env.NODE_ENV && warning(!1, "readFragment(...) was called with an empty fragment.\nYou have to call it with at least one fragment in your GraphQL document.", 6);
    return null;
  }

  var typename = getFragmentTypeName(fragment);

  if ("string" != typeof entity && !entity.__typename) {
    entity.__typename = typename;
  }

  var entityKey = "string" != typeof entity ? store.keyOfEntity(_extends({
    __typename: typename
  }, entity)) : entity;

  if (!entityKey) {
    "production" !== process.env.NODE_ENV && warning(!1, "Can't generate a key for readFragment(...).\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + typename + "`.", 7);
    return null;
  }

  return readSelection({
    parentTypeName: typename,
    parentKey: entityKey,
    parentFieldKey: "",
    fieldName: "",
    variables: variables || {},
    fragments: fragments,
    partial: !1,
    store: store,
    schemaPredicates: store.schemaPredicates
  }, entityKey, getSelectionSet(fragment), Object.create(null)) || null;
};

var readSelection = function readSelection(ctx, entityKey, select, data) {
  var store = ctx.store;
  var schemaPredicates = ctx.schemaPredicates;
  var isQuery = entityKey === store.getRootKey("query");

  if (!isQuery) {
    addDependency(entityKey);
  }

  var typename = isQuery ? entityKey : store.getField(entityKey, "__typename");

  if ("string" != typeof typename) {
    return;
  }

  data.__typename = typename;
  var iter = new SelectionIterator(typename, entityKey, select, ctx);
  var node;
  var hasFields = !1;
  var hasPartials = !1;

  while (void 0 !== (node = iter.next())) {
    var fieldName = getName(node);
    var fieldArgs = getFieldArguments(node, ctx.variables);
    var fieldAlias = getFieldAlias(node);
    var fieldKey = joinKeys(entityKey, keyOfField(fieldName, fieldArgs));
    var fieldValue = store.getRecord(fieldKey);

    if (isQuery) {
      addDependency(fieldKey);
    }

    if ("production" !== process.env.NODE_ENV && schemaPredicates && typename) {
      schemaPredicates.isFieldAvailableOnType(typename, fieldName);
    }

    var dataFieldValue = void 0;
    var resolvers = store.resolvers[typename];

    if (void 0 !== resolvers && "function" == typeof resolvers[fieldName]) {
      ctx.parentTypeName = typename;
      ctx.parentKey = entityKey;
      ctx.parentFieldKey = fieldKey;
      ctx.fieldName = fieldName;

      if (void 0 !== fieldValue) {
        data[fieldAlias] = fieldValue;
      }

      var resolverValue = resolvers[fieldName](data, fieldArgs || Object.create(null), store, ctx);

      if (void 0 !== node.selectionSet) {
        dataFieldValue = resolveResolverResult(ctx, typename, fieldName, fieldKey, getSelectionSet(node), data[fieldAlias] || Object.create(null), resolverValue);
      } else {
        dataFieldValue = void 0 === resolverValue && void 0 === schemaPredicates ? null : resolverValue;
      }
    } else if (void 0 === node.selectionSet) {
      dataFieldValue = fieldValue;
    } else {
      var link = store.getLink(fieldKey);

      if (void 0 !== link) {
        dataFieldValue = resolveLink(ctx, link, typename, fieldName, getSelectionSet(node), data[fieldAlias]);
      } else if ("object" == typeof fieldValue && null !== fieldValue) {
        dataFieldValue = fieldValue;
      }
    }

    if (void 0 === dataFieldValue && void 0 !== schemaPredicates && schemaPredicates.isFieldNullable(typename, fieldName)) {
      hasPartials = !0;
      data[fieldAlias] = null;
    } else if (void 0 === dataFieldValue) {
      return;
    } else {
      hasFields = !0;
      data[fieldAlias] = dataFieldValue;
    }
  }

  if (hasPartials) {
    ctx.partial = !0;
  }

  return isQuery && hasPartials && !hasFields ? void 0 : data;
};

var resolveResolverResult = function resolveResolverResult(ctx, typename, fieldName, key, select, prevData, result) {
  if (Array.isArray(result)) {
    var schemaPredicates = ctx.schemaPredicates;
    var isListNullable = void 0 === schemaPredicates || schemaPredicates.isListNullable(typename, fieldName);
    var data = new Array(result.length);

    for (var i = 0, l = result.length; i < l; i++) {
      var childResult = resolveResolverResult(ctx, typename, fieldName, joinKeys(key, "" + i), select, void 0 !== prevData ? prevData[i] : void 0, result[i]);

      if (void 0 === childResult && !isListNullable) {
        return;
      } else {
        data[i] = void 0 !== childResult ? childResult : null;
      }
    }

    return data;
  } else if (null == result) {
    return null;
  } else if (isDataOrKey(result)) {
    var data$1 = void 0 === prevData ? Object.create(null) : prevData;
    return "string" == typeof result ? readSelection(ctx, result, select, data$1) : function (ctx, key, select, data, result) {
      var store = ctx.store;
      var schemaPredicates = ctx.schemaPredicates;
      var entityKey = store.keyOfEntity(result) || key;
      addDependency(entityKey);
      var resolvedTypename = result.__typename;
      var typename = store.getField(entityKey, "__typename") || resolvedTypename;

      if ("string" != typeof typename || resolvedTypename && typename !== resolvedTypename) {
        "production" !== process.env.NODE_ENV && warning(!1, "Invalid resolver data: The resolver at `" + entityKey + "` returned an invalid typename that could not be reconciled with the cache.", 8);
        return;
      }

      data.__typename = typename;
      var iter = new SelectionIterator(typename, entityKey, select, ctx);
      var node;
      var hasFields = !1;
      var hasPartials = !1;

      while (void 0 !== (node = iter.next())) {
        var fieldName = getName(node);
        var fieldAlias = getFieldAlias(node);
        var fieldKey = joinKeys(entityKey, keyOfField(fieldName, getFieldArguments(node, ctx.variables)));
        var fieldValue = store.getRecord(fieldKey);
        var resultValue = result[fieldName];

        if ("production" !== process.env.NODE_ENV && schemaPredicates && typename) {
          schemaPredicates.isFieldAvailableOnType(typename, fieldName);
        }

        var dataFieldValue = void 0;

        if (void 0 !== resultValue && void 0 === node.selectionSet) {
          dataFieldValue = resultValue;
        } else if (void 0 === node.selectionSet) {
          dataFieldValue = fieldValue;
        } else if (void 0 !== resultValue) {
          dataFieldValue = resolveResolverResult(ctx, typename, fieldName, fieldKey, getSelectionSet(node), data[fieldAlias], resultValue);
        } else {
          var link = store.getLink(fieldKey);

          if (void 0 !== link) {
            dataFieldValue = resolveLink(ctx, link, typename, fieldName, getSelectionSet(node), data[fieldAlias]);
          } else if ("object" == typeof fieldValue && null !== fieldValue) {
            dataFieldValue = fieldValue;
          }
        }

        if (void 0 === dataFieldValue && void 0 !== schemaPredicates && schemaPredicates.isFieldNullable(typename, fieldName)) {
          hasPartials = !0;
          data[fieldAlias] = null;
        } else if (void 0 === dataFieldValue) {
          return;
        } else {
          hasFields = !0;
          data[fieldAlias] = dataFieldValue;
        }
      }

      if (hasPartials) {
        ctx.partial = !0;
      }

      return !hasFields ? void 0 : data;
    }(ctx, key, select, data$1, result);
  } else {
    "production" !== process.env.NODE_ENV && warning(!1, "Invalid resolver value: The field at `" + key + "` is a scalar (number, boolean, etc), but the GraphQL query expects a selection set for this field.", 9);
    return;
  }
};

var resolveLink = function resolveLink(ctx, link, typename, fieldName, select, prevData) {
  if (Array.isArray(link)) {
    var schemaPredicates = ctx.schemaPredicates;
    var isListNullable = void 0 !== schemaPredicates && schemaPredicates.isListNullable(typename, fieldName);
    var newLink = new Array(link.length);

    for (var i = 0, l = link.length; i < l; i++) {
      var childLink = resolveLink(ctx, link[i], typename, fieldName, select, void 0 !== prevData ? prevData[i] : void 0);

      if (void 0 === childLink && !isListNullable) {
        return;
      } else {
        newLink[i] = void 0 !== childLink ? childLink : null;
      }
    }

    return newLink;
  } else if (null === link) {
    return null;
  } else {
    return readSelection(ctx, link, select, void 0 === prevData ? Object.create(null) : prevData);
  }
};

var isDataOrKey = function isDataOrKey(x) {
  return "string" == typeof x || "object" == typeof x && "string" == typeof x.__typename;
};

var SchemaPredicates = function SchemaPredicates(schema) {
  this.schema = buildClientSchema(schema);
};

SchemaPredicates.prototype.isFieldNullable = function isFieldNullable(typename, fieldName) {
  var field = getField(this.schema, typename, fieldName);

  if (void 0 === field) {
    return !1;
  }

  return isNullableType(field.type);
};

SchemaPredicates.prototype.isListNullable = function isListNullable(typename, fieldName) {
  var field = getField(this.schema, typename, fieldName);

  if (void 0 === field) {
    return !1;
  }

  var ofType = isNonNullType(field.type) ? field.type.ofType : field.type;
  return isListType(ofType) && isNullableType(ofType.ofType);
};

SchemaPredicates.prototype.isFieldAvailableOnType = function isFieldAvailableOnType(typename, fieldname) {
  return !!getField(this.schema, typename, fieldname);
};

SchemaPredicates.prototype.isInterfaceOfType = function isInterfaceOfType(typeCondition, typename) {
  if (!typename || !typeCondition) {
    return !1;
  }

  if (typename === typeCondition) {
    return !0;
  }

  var abstractType = this.schema.getType(typeCondition);
  expectAbstractType(abstractType, typeCondition);
  var objectType = this.schema.getType(typename);
  expectObjectType(objectType, typename);
  return this.schema.isPossibleType(abstractType, objectType);
};

var getField = function getField(schema, typename, fieldName) {
  var object = schema.getType(typename);
  expectObjectType(object, typename);
  var field = object.getFields()[fieldName];

  if (void 0 === field) {
    "production" !== process.env.NODE_ENV && warning(!1, "Invalid field: The field `" + fieldName + "` does not exist on `" + typename + "`, but the GraphQL document expects it to exist.\nTraversal will continue, however this may lead to undefined behavior!", 4);
    return;
  }

  return field;
};

var expectObjectType = function expectObjectType(type, typename) {
  invariant(type instanceof GraphQLObjectType, "production" !== process.env.NODE_ENV ? "Invalid Object type: The type `" + typename + "` is not an object in the defined schema, but the GraphQL document is traversing it." : "", 3);
};

var expectAbstractType = function expectAbstractType(type, typename) {
  invariant(type instanceof GraphQLInterfaceType || type instanceof GraphQLUnionType, "production" !== process.env.NODE_ENV ? "Invalid Abstract type: The type `" + typename + "` is not an Interface or Union type in the defined schema, but a fragment in the GraphQL document is using it as a type condition." : "", 5);
};

var addCacheOutcome = function addCacheOutcome(op, outcome) {
  return _extends(_extends({}, op), {
    context: _extends(_extends({}, op.context), {
      meta: _extends(_extends({}, op.context.meta), {
        cacheOutcome: outcome
      })
    })
  });
};

var addTypeNames = function addTypeNames(op) {
  return _extends(_extends({}, op), {
    query: formatDocument(op.query)
  });
};

var getRequestPolicy = function getRequestPolicy(op) {
  return op.context.requestPolicy;
};

var isQueryOperation = function isQueryOperation(op) {
  return "query" === op.operationName;
};

var isCacheableQuery = function isCacheableQuery(op) {
  return isQueryOperation(op) && "network-only" !== getRequestPolicy(op);
};

var toRequestPolicy = function toRequestPolicy(operation, requestPolicy) {
  return _extends(_extends({}, operation), {
    context: _extends(_extends({}, operation.context), {
      requestPolicy: requestPolicy
    })
  });
};

function _ref2$1(op) {
  return isCacheableQuery(op);
}

function _ref3(res) {
  return addCacheOutcome(res.operation, res.outcome);
}

function _ref4(res) {
  return "miss" === res.outcome;
}

function _ref6(res) {
  return "miss" !== res.outcome;
}

function _ref7(op) {
  return !isCacheableQuery(op);
}

var cacheExchange = function cacheExchange(opts) {
  return function (ref) {
    var forward = ref.forward;
    var client = ref.client;

    if (!opts) {
      opts = {};
    }

    var store = new Store(opts.schema ? new SchemaPredicates(opts.schema) : void 0, opts.resolvers, opts.updates, opts.optimistic, opts.keys);
    var optimisticKeys = new Set();
    var ops = new Map();
    var deps = Object.create(null);

    var collectPendingOperations = function collectPendingOperations(pendingOperations, dependencies) {
      if (void 0 !== dependencies) {
        dependencies.forEach(function _ref(dep) {
          var keys = deps[dep];

          if (void 0 !== keys) {
            deps[dep] = [];

            for (var i = 0, l = keys.length; i < l; i++) {
              pendingOperations.add(keys[i]);
            }
          }
        });
      }
    };

    var executePendingOperations = function executePendingOperations(operation, pendingOperations) {
      pendingOperations.forEach(function (key) {
        if (key !== operation.key) {
          var op = ops.get(key);

          if (void 0 !== op) {
            ops["delete"](key);
            client.reexecuteOperation(toRequestPolicy(op, "cache-first"));
          }
        }
      });
    };

    var optimisticUpdate = function optimisticUpdate(operation) {
      if (function (op) {
        return "mutation" === op.operationName;
      }(op = operation) && "network-only" !== getRequestPolicy(op)) {
        var key = operation.key;
        var dependencies = writeOptimistic(store, operation, key).dependencies;

        if (0 !== dependencies.size) {
          optimisticKeys.add(key);
          var pendingOperations = new Set();
          collectPendingOperations(pendingOperations, dependencies);
          executePendingOperations(operation, pendingOperations);
        }
      }

      var op;
    };

    var updateDependencies = function updateDependencies(op, dependencies) {
      dependencies.forEach(function (dep) {
        (deps[dep] || (deps[dep] = [])).push(op.key);

        if (!ops.has(op.key)) {
          ops.set(op.key, "network-only" === getRequestPolicy(op) ? toRequestPolicy(op, "cache-and-network") : op);
        }
      });
    };

    var operationResultFromCache = function operationResultFromCache(operation) {
      var ref = query(store, operation);
      var data = ref.data;
      var partial = ref.partial;
      var cacheOutcome;

      if (null === data) {
        cacheOutcome = "miss";
      } else {
        updateDependencies(operation, ref.dependencies);
        cacheOutcome = !partial || "cache-only" === getRequestPolicy(operation) ? "hit" : "partial";
      }

      return {
        outcome: cacheOutcome,
        operation: operation,
        data: data
      };
    };

    var updateCacheWithResult = function updateCacheWithResult(result) {
      var operation = result.operation;
      var error = result.error;
      var extensions = result.extensions;
      var isQuery = isQueryOperation(operation);
      var data = result.data;
      var key = operation.key;

      if (optimisticKeys.has(key)) {
        optimisticKeys["delete"](key);
        store.clearOptimistic(key);
      }

      var writeDependencies, queryDependencies;

      if (null != data) {
        writeDependencies = write(store, operation, data).dependencies;

        if (isQuery) {
          var queryResult = query(store, operation);
          data = queryResult.data;
          queryDependencies = queryResult.dependencies;
        } else {
          data = query(store, operation, data).data;
        }
      }

      var pendingOperations = new Set();
      collectPendingOperations(pendingOperations, writeDependencies);

      if (isQuery) {
        collectPendingOperations(pendingOperations, queryDependencies);
      }

      executePendingOperations(result.operation, pendingOperations);

      if (isQuery && void 0 !== queryDependencies) {
        updateDependencies(result.operation, queryDependencies);
      }

      return {
        data: data,
        error: error,
        extensions: extensions,
        operation: operation
      };
    };

    function _ref5(res) {
      var operation = res.operation;
      var outcome = res.outcome;
      var policy = getRequestPolicy(operation);

      if ("cache-and-network" === policy || "cache-first" === policy && "partial" === outcome) {
        client.reexecuteOperation(toRequestPolicy(operation, "network-only"));
      }

      return {
        operation: addCacheOutcome(operation, outcome),
        data: res.data,
        error: res.error,
        extensions: res.extensions
      };
    }

    return function (ops$) {
      var sharedOps$ = share(tap(optimisticUpdate)(map(addTypeNames)(ops$)));
      var cache$ = share(map(operationResultFromCache)(filter(_ref2$1)(sharedOps$)));
      var cacheOps$ = map(_ref3)(filter(_ref4)(cache$));
      var cacheResult$ = map(_ref5)(filter(_ref6)(cache$));
      var result$ = map(updateCacheWithResult)(forward(merge([filter(_ref7)(sharedOps$), cacheOps$])));
      return merge([result$, cacheResult$]);
    };
  };
};

export { Store, cacheExchange, query, read, write, writeFragment, writeOptimistic };